import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HeroFullOverlay } from '@cotyorg/ccx-organism-hero';
import Heading from '@cotyorg/ccx-atoms/Heading';
import { CardoGroup } from '@cotyorg/ccx-organism-cardo-group';
import { CardoList } from '@cotyorg/ccx-organism-cardo-list';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';
import SubcategoryNavigation from '../../organisms/SubcategoryNavigation';
import SectionHeader from '../../atoms/SectionHeader';
import StandardLayout from '../../templates/StandardLayout';
import {
  newCardoGroupBreakpointConfig,
  newCardListBreakpointConfig,
} from './cardo.config';
import { isLargeBreakpoint } from '../../utils';

const NewComponent = ({
  currentBreakpoint,
  subNavigationItems,
  products,
  sectionHeadings,
  cardoGroup,
}) => (
  <StandardLayout>
    <div className="new-page">
      <div className="pre-offset-vertical">
        <div className="grid-container">
          <div className="grid-x grid-margin-x">
            <div className="cell">
              <div className="hero-absolute-image">
                <HeroFullOverlay
                  isContentFirst={isLargeBreakpoint({ currentBreakpoint })}
                  heroStoreDataKey="hero1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="offset-vertical">
        <div className="grid-container">
          <div className="grid-x">
            <div className="cell large-4 medium-16">
              <div className="subcategory-navigation-wrapper">
                <SubcategoryNavigation items={subNavigationItems} />
              </div>
            </div>

            <div className="cell large-12 medium-16">
              <CardoList
                data={products}
                extraClass="product-list"
                hideDescription
                contentTheme="transparent"
                breakpointConfig={newCardListBreakpointConfig}
                isTitleUnderlined={false}
                isSmallTitle
                headingLevel={5}
                tagHeadingLevel={6}
                fixedHeight
                zoomOnHover
                showMoreIconSrc="/ccx-files/assets/plus-within-circle.svg"
              />
            </div>
          </div>
        </div>
      </div>

      <OptionalSection
        renderCondition={
          R.path(['cardSection1Cards', 'length'], cardoGroup) > 0
        }
        section={() => (
          <div className="grid-container">
            <OptionalSection
              renderCondition={
                R.path(['cardSection1Heading', 'heading'], sectionHeadings) ||
                R.path(['cardSection1Heading', 'introduction'], sectionHeadings)
              }
              section={() => (
                <div className="grid-x grid-margin-x">
                  <div className="cell">
                    <SectionHeader>
                      <Heading extraClass="section__title" level={2}>
                        {R.path(['cardSection1Heading', 'heading'])(
                          sectionHeadings
                        )}
                      </Heading>

                      <Heading extraClass="section__sub-title" level={3}>
                        {R.path(['cardSection1Heading', 'introduction'])(
                          sectionHeadings
                        )}
                      </Heading>
                    </SectionHeader>
                  </div>
                </div>
              )}
            />

            <div className="grid-x grid-padding-x flex-container align-middle align-center">
              <CardoGroup
                data="cardSection1Cards"
                contentTheme="alpha"
                baseBreakpointConfig={newCardoGroupBreakpointConfig}
              />
            </div>
          </div>
        )}
      />
    </div>
  </StandardLayout>
);

NewComponent.propTypes = {
  currentBreakpoint: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.object),
  sectionHeadings: PropTypes.objectOf(PropTypes.object),
  subNavigationItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      url: PropTypes.string,
      productCount: PropTypes.number,
    })
  ).isRequired,
  cardoGroup: PropTypes.objectOf(PropTypes.object),
};

export default connect(({ content, breakpoints }) => ({
  currentBreakpoint: R.prop('current', breakpoints),
  products: R.pathOr([], ['cards', 'products'])(content),
  sectionHeadings: R.prop('sectionHeadings', content),
  subNavigationItems: R.prop('subNavigationItems')(content),
  cardoGroup: R.prop('cardoGroup', content),
}))(NewComponent);
